<template>
    <div>
        <h1>Ooops :(</h1>
        <p>My system doesn't know what to do.</p>
        <h3>Want to help it understand?</h3>
        <p>Send a pull request to <a href="/does-not-exist">this repo</a>.</p>
        <h3>Navigation</h3>
        <LinkBox>
            <li><router-link to="/">Goto: home</router-link></li>
        </LinkBox>
    </div>
</template>

<script>
import LinkBox from '@/components/LinkBox.vue'

export default {
    name: 'unsupported',
    components: {
        LinkBox
    }
}
</script>
